import { useCallback, useRef } from "react";

// Use this hook only if you want to save query params without re mounting the components
// the changes made with window are not tracked by the useHistory hook, you need to refresh the page so useHistory'll have access to the query params saved.
export function useWindowQueryParams() {
  const queryParams = useRef(new URLSearchParams(window.location.search));

  const deleteWindowQueryParam = useCallback((param: string) => {
    const url = new URL(window.location.toString());
    queryParams.current.delete(param);
    url.search = queryParams.current.toString();
    window.history.pushState(null, "", url.toString());
  }, []);

  return { deleteWindowQueryParam };
}
